import { EnumListEvents, EnumListItem } from '../../gzEnumList/types';
import { GzOperatingSystemFilterWebComponent } from '../component/GzOperatingSystemFilterWebComponent';
import { OperatingSystemListEvents } from '../types';

export class GzOperatingSystemFilterController {
  private dependencies: any;
  private component: GzOperatingSystemFilterWebComponent;

  constructor(dependencies: any, component: GzOperatingSystemFilterWebComponent) {
    if (this.dependencies) {
      return;
    }
    this.dependencies = dependencies;
    this.component = component;
    this.addEventListeners();
  }

  private addEventListeners(): void {
    this.component.addEventListener(EnumListEvents.SELECTION_CHANGE, this.handleSelectionChange.bind(this));
  }

  private async handleSelectionChange(event: CustomEvent): Promise<void> {
    const selectedValues = event.detail.selectedValues.map(String);
    this.component.selectedFilterOptions = selectedValues;
    this.component.dispatchEvent(
      new CustomEvent(OperatingSystemListEvents.OPERATING_SYSTEM_SELECTION_CHANGED, {
        detail: { selectedFilterOptions: selectedValues },
        bubbles: true,
        composed: true,
      })
    );
  }

  public getAllOptionsValues(): (string | number)[] {
    const filterOptions = this.dependencies.api.clients.OperatingSystems.getOperatingSystemTypes();
    return filterOptions.map(option => option.value.toString());
  }

  public setFilterOptions(operatingSystems: (string | number)[] | undefined): void {
    const filterOptions = this.dependencies.api.clients.OperatingSystems.getOperatingSystemTypes();
    const newOptions: Array<EnumListItem> = [];
    const selectedFilterOptions: Array<EnumListItem> = [];
    if (operatingSystems === undefined || operatingSystems === null) {
      operatingSystems = [];
    }
    for (const option of filterOptions) {
      option.label = option.name;
      //if the provided operatingSystems is empty all the values are selected
      if (operatingSystems.length === 0) {
        selectedFilterOptions.push(option.value);
        option.selected = true;
      }
      //else only options from operatingSystems are selected
      else {
        option.selected = operatingSystems.includes(option.value.toString());
        if (option.selected) {
          selectedFilterOptions.push(option.value);
        }
      }
      newOptions.push(option);
    }
    this.component.filterOptions = newOptions;
    this.component.selectedFilterOptions = selectedFilterOptions.map(String);
  }
}
